export default class Message {
    constructor() {
        this.content = '',
        this.subtitle = '',
        this.header = '',
        this.artist = null,
        this.effect = false, 
        this.background = null,
        this.backgroundType = null,
        this.backgroundTransition = 'fade',
        this.waitForSubmit = false;
        this.clean = true;
    }
    setContent(_content) {
        this.content = _content
        return this;
    }
    setSubtitle(_subtitle) {
        this.subtitle = _subtitle
        return this;
    }
    setHeader(_header) {
        this.header = _header
        return this;
    }
    setArtist(_artist) {
        this.artist = _artist
        return this;
    }
    setEffect(_effect) {
        this.effect = _effect
        return this;
    }
    setBackground(_background) {
        this.background = _background
        return this;
    }
    setBackgroundType(_backgroundType) {
        this.backgroundType = _backgroundType
        return this;
    }
    setBackgroundTransition(_backgroundTransition) {
        this.backgroundTransition = _backgroundTransition
        return this;
    }
    setWaitForSubmit(_waitForSubmit) {
        this.waitForSubmit = _waitForSubmit
        return this;
    }
    setClean(_clean) {
        this.clean = _clean;
        return this;
    }
}